import React from 'react';
import env from 'env';
import { useRouter, SiteLink } from 'components';
import { useGet } from 'components';
//import { Button, ErrorMessage } from 'components';
import { ErrorPopup } from 'components';
import utils from 'utils';

export function JoinView(props) {
    const { query } = useRouter();
    const get = useGet();

    const joinId = query.id || '';

    React.useEffect(() => {
        get.send(env.apiBase + `/api/joinadmin/getregistration/${joinId}`);
        // eslint-disable-next-line
    }, []);

    if (get.loading()) {
        return <div>Loading...</div>
    } else if (get.hasErrors()) {
        return <ErrorPopup title="Loading Error" errors={get.errors} />
    }

    
    const data = get.response;

    console.log('data --- ', data);

    return <Join data={data} joinId={joinId} />
}


function Join({ data }) {
    return <div>
        <h1>Join Registration</h1>
        <div style={{ margin: '1rem 0' }}>
            <SiteLink to="/admin/join"> &lt; Back to list</SiteLink>
        </div>
        <div className="row">
            
            <div className="col-md-6">
                <Fld name="First Name" value={data.firstName} />
                <Fld name="Last Name" value={data.lastName} />
                <Fld name="Email" value={data.email} />
                <Fld name="Dob" value={data.dob} />
                <Fld name="Mobile" value={data.mobile} />
                <Fld name="Postcode" value={data.postcode} />
                <Fld name="Interests" value={(data.interests || []).join('\n')} />
            </div>
            
            <div className="col-md-6">
                <Fld name="Date Registered" value={utils.date.formatYYYYMMDD(data.dateRegistered)} />
                <div className="row">
                    <div className="col-md-3">Receipts:</div>
                    <div className="col-md-9">
                        {data.fileAttachments && data.fileAttachments.map((file, index) => <div key={index}>
                            <a href={`${env.apiBase}/api/warrantyAdmin/getFile?file=${encodeURIComponent(file.filePath)}`} target="_blank" rel="noopener noreferrer">{file.fileName}</a>
                        </div>)}
                    </div>
                </div>

                <hr />
                <h4 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Mailchimp integration</h4>

                <Fld name="Status" value={data.mailchimpStatus === 1 ? 'Sent' : (data.mailchimpStatus === 99 ? 'Error' : 'N/A')} />
                <Fld name="Date sent" value={utils.date.formatYYYYMMDD(data.mailchimpDateSent)} />
                {data.mailchimpStatus === 99 && <Fld name="Error Message" value={data.mailchimpMessage} />}
                {/* <ResendMailchimp id={data.warrantyRegistrationId} /> */}
            </div>
        </div>
    </div>

}


function Fld({ name, value }) {
    return <div className="row">
        <div className="col-md-3">{name}:</div>
        <div className="col-md-9" style={{ whiteSpace: 'pre-line' }}>{value}</div>
    </div>
}